import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsOptions";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

myListsDetailsOptionsStyles.selectAllGridItem = {
    ...myListsDetailsOptionsStyles.selectAllGridItem,
    css: css`
        ${myListsDetailsOptionsStyles.selectAllGridItem?.css}
        ${mediaQueriesBP.maxMD} {
            padding-top: 16px;
        }
    `,
};

myListsDetailsOptionsStyles.search = {
    ...myListsDetailsOptionsStyles.search,
    cssOverrides: {
        ...myListsDetailsOptionsStyles.search?.cssOverrides,
        inputSelect: css`
            min-height: 50px !important;

            & + span {
                min-height: 50px !important;
            }
        `,
    },
};

myListsDetailsOptionsStyles.rightColumnWrapper = {
    ...myListsDetailsOptionsStyles.rightColumnWrapper,
    css: css`
        ${myListsDetailsOptionsStyles.rightColumnWrapper?.css}
        button {
            height: 50px !important;
            min-height: 50px !important;
        }
    `,
};